Jelly.Watch_Address_Bar = function()
{
	// The consumer dashboard is a full-page React Router island. Keep Jelly's
	// path bookkeeping current, but let React handle its internal navigation.
	if (document.getElementById("root-consumer-dashboard")) {
		Jelly.Current_Path = Jelly.URL.Get_Path_From_Location();
		return;
	}

	if (!Jelly.Lock_Watch_Address_Bar) {
		// Called on an interval, compares the new path against the registered path, triggering a changed container when the path has changed.

		// Get current path (ignore hash, include pathname+search).
		var New_Path = Jelly.URL.Get_Path_From_Location();
		
		// Check if path has changed.
		if (Jelly.Current_Path === null)
			Jelly.Current_Path = New_Path;

		if (New_Path != Jelly.Current_Path)
		{
			// Store current path.
			Jelly.Current_Path = New_Path;
			
	// 		Jelly.Debug.Log(New_Path);
			
			// Register path changed.
			// TODO: "We'll know." - Kunal Gupta (2014)
			
			// TODO - this always happens, maybe it can have a little abstraction too.
			// Cleanup content-specifc states
			Jelly.jQuery('#Jelly_Wrapper').removeClass("Content_Navigator_Visible");
			
			// TODO - generalize
			if (Jelly.Current_Path.toLowerCase() != "page/video_hangout") {
				Jelly.References.Trigger_Refresh({"Kind": "Path"});
			
				// Refresh all references.
				Jelly.References.Refresh_All();
			}
		}
	}
	else { 
		// console.log("Address Locked");
	}
};

// TODO: not using path parts as an array until Containers are implemented
// TODO: This is all leftover code from path parts array

/*
// Split path
var New_Path_Parts = New_Path.split("/");
//		for (var Path_Index in New_Path_Parts)


var Path_Index = 0;
{		

	if (New_Path != Jelly.Current_Path)
//			if (New_Path_Parts[Path_Index] != Jelly.Current_Path_Parts[Path_Index])
	{

		Jelly.Current_Path = New_Path;
		
//				Jelly.Debug.Log("YO");
//				Jelly.Debug.Log(Path_Index);			
		var Item_Key = "Container";
		if (Jelly.References.Items[Item_Key])
		{

			for (var Reference_Index in Jelly.References.Items[Item_Key])
			{
				Reference = Jelly.References.Items[Item_Key][Reference_Index];
				// Mark reference to be refreshed
				Jelly.References.References_To_Refresh[Reference["Namespace"]] = Reference;						
				if (Reference["Level"] == Path_Index)
				{

				}
			}
		}
		
		Jelly.References.Refresh_All();
		
//				break;
	}
}
*/
